import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { GooleAnalyticsEventsService } from '../services/goole-analytics-events.service';

import { RateUsDialogComponent } from './rate-us-dialog/rate-us-dialog.component';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [MatButton, RouterLink]
})
export class FooterComponent implements OnInit {
  // this is the better solution than rather trying to get the mat-icon registry working here
  facebookIcon = './../../../assets/images/icons/facebook_icon.png';
  twitterIcon = './../../../assets/images/icons/twitter_icon.png';
  instagramIcon = './../../../assets/images/icons/instagram_icon.png';
  tiktokIcon = './../../../assets/images/icons/tiktok_icon.png';
  sadIcon = './../../../assets/images/icons/sad_icon.png';
  mehIcon = './../../../assets/images/icons/meh_icon.png';
  smileIcon = './../../../assets/images/icons/smile_icon.png';

  // tslint:disable-next-line: max-line-length
  constructor(private googleAnalyticsEvents: GooleAnalyticsEventsService, private dialog: MatDialog) { }

  ngOnInit() {
  }

  showRatingModal(rating: string) {
    if (rating === 'Poor') {
      this.googleEvent('how do you feel about us', 'Poor');
    } else if (rating === 'Ok') {
      this.googleEvent('how do you feel about us', 'Ok');
    } else if (rating === 'Good') {
      this.googleEvent('how do you feel about us', 'Good');
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      usersRating: rating
    };
    this.dialog.open(RateUsDialogComponent, dialogConfig);
  }

  googleEvent(section, cardTitle) {
    this
      .googleAnalyticsEvents
      .eventEmitter(cardTitle, 'footer - ' + section, 'footer', 10);
  }

}
